import React from 'react';
import { Button, Pane, FormField, TagInput } from 'evergreen-ui';

const TagInputField = ({
  placeholder,
  label,
  required,
  description,
  validationMessage,
  isInvalid,
  formikBag,
  onChange,
  value,
  ...props
}: any) => {
  const isEmpty = !value || value.length === 0;
  return (
    <FormField
      label={label}
      isRequired={required}
      description={description}
      validationMessage={validationMessage}
      width="100%"
      marginBottom={isEmpty ? 24 : 16}
    >
      <TagInput
        {...props}
        values={value || []}
        onChange={(values: any) => {
          formikBag.setFieldTouched(props.name);
          formikBag.setFieldValue(props.name, values);
        }}
        width="100%"
        inputProps={{ placeholder: placeholder }}
      />
      {!isEmpty && (
        <Pane display="flex" justifyContent="flex-end" marginTop={8}>
          <Button
            type="button"
            appearance="minimal"
            height={20}
            onClick={() => {
              formikBag.setFieldTouched(props.name);
              formikBag.setFieldValue(props.name, []);
            }}
          >
            Clear all
          </Button>
        </Pane>
      )}
    </FormField>
  );
};

export default TagInputField;
